var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9743 32.3735L7.62631 1.02538C6.25914 -0.341793 4.04257 -0.341793 2.67747 1.02538L1.02538 2.67496C-0.341793 4.04257 -0.341793 6.25914 1.02538 7.62413L32.3734 38.9722C33.741 40.3394 35.9575 40.3394 37.3225 38.9722L38.9721 37.3226C40.3419 35.9576 40.3419 33.7406 38.9743 32.3735Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3734 1.02542L1.02538 32.3735C-0.341793 33.7407 -0.341793 35.9577 1.02538 37.3227L2.67496 38.9723C4.04257 40.3394 6.25914 40.3394 7.62413 38.9723L38.9743 7.62635C40.3419 6.25918 40.3419 4.04261 38.9743 2.67762L37.3247 1.02804C35.9575 -0.341755 33.741 -0.341755 32.3734 1.02542Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.37031304f6b699df2d879131e26414f1.svg";
export { ForwardRef as ReactComponent };